export const HelloBuyerAppH5Config = {
  iosAppStoreUrl: 'https://apps.apple.com/cn/app/%E5%9C%86%E9%A2%86/id1524263993',
  androidApkUrl: 'https://www.yuanling.com/app/buyer-app.apk',
  shareButtonLabel: '打开圆领',
  downloadButtonLabel: '下载圆领APP',
  documentTitle: '打开圆领',
} as const;
